// 部品 ボタン左寄せ用棚
import React from 'react';
import { Row, Col } from 'react-bootstrap';

const RowLeftButton: React.FC = ({ children }) => {
  return (
    <Row className="row-left-button">
      <Col className="text-left" xl={6} lg={6} md={6} sm={6} xs={12}>
        {children}
      </Col>
      <Col xl={6} lg={6} md={6} sm={6} xs={12} />
    </Row>
  );
};

export default RowLeftButton;
